'use client';

import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../api/client';

type InstallationStatus = {
  status: 'pending' | 'active' | 'missing';
  organizationId?: string;
  installationId?: string | number;
  message?: string;
};

export function useInstallationStatus() {
  const {
    getToken,
    isLoaded,
    isSignedIn,
    orgId: clerkOrganizationId,
  } = useAuth();

  return useQuery<InstallationStatus>({
    queryKey: ['installation-status', clerkOrganizationId],
    enabled: isLoaded && isSignedIn === true && !!clerkOrganizationId,
    queryFn: async () => {
      const token = await getToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const { data, error } = await apiClient.GET('/api/v1/onboarding/status', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (error) {
        throw new Error('Failed to fetch installation status');
      }

      return data as InstallationStatus;
    },
    staleTime: 30000,
    refetchInterval: 60000,
    retry: false,
  });
}
